import { render } from "./GameM.vue?vue&type=template&id=f944e200&scoped=true"
import script from "./GameM.vue?vue&type=script&lang=js"
export * from "./GameM.vue?vue&type=script&lang=js"

import "./GameM.vue?vue&type=style&index=0&id=f944e200&lang=scss&scoped=true"

import exportComponent from "G:\\官网\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f944e200"]])

export default __exports__